import * as React from 'react'

import { Box, Radio } from '@factorialco/deprecated-design-system'
import { AtsJobPostingStatusesEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onChange: (status: AtsJobPostingStatusesEnum) => void
  currentStatus: AtsJobPostingStatusesEnum
}

export const PublishModalOptions = ({ currentStatus, onChange }: Props) => {
  return (
    <Box gap="s6">
      <Radio.Wrap>
        <Radio
          name="jobs_section_type"
          option={{
            label: i18n.t('ats.job_details.publish_confirmation.publish.label'),
            value: 'published',
          }}
          description={i18n.t('ats.job_details.publish_confirmation.publish.description')}
          value={currentStatus}
          onChange={() => onChange('published')}
        />
      </Radio.Wrap>
      <Radio.Wrap>
        <Radio
          name="jobs_section_type"
          option={{
            label: i18n.t('ats.job_details.publish_confirmation.unlist.label'),
            value: 'unlisted',
          }}
          value={currentStatus}
          description={i18n.t('ats.job_details.publish_confirmation.unlist.description')}
          onChange={() => onChange('unlisted')}
        />
      </Radio.Wrap>
    </Box>
  )
}
